export default {
    "title": "Administration panel / Clients",
    "description": "List of clients currently registered",
    "clientsTableHeader": "Total: <0>{{count}}</0> | Active: <0>{{countActive}}</0> | Inactive: <0>{{countInactive}}</0>",
    "clientName": "Client name",
    "clientsTableColumns": {
        "client_name": "Client name",
        "client_id": "SAP ID",
        "cif": "CIF",
        "date": "Discharge date",
        "users_count": "Number of users",
        "state": "State"
    },
    "popover": {
        "edit": "Edit",
        "activate": "Activate",
        "deactivate": "Deactivate",
        "documentation": "Documentation",
        "delete": "Delete"
    },
    "newClientDialog": {
        "title": "Create client",
        "input": {
            "name": "Name *",
            "placeholder_name": "New client name",
            "sap": "SAP Identifier *",
            "placeholder_sap": "New client SAP identifier",
            "nif": "NIF *",
            "placeholder_nif": "New client NIF",
            "cancel": "Cancel"
        }
    },
    "servicesSection": {
        "title": "Services"
    },
    "editClientDialog": {
        "title": "Edit client",
        "input": {
            "name": "Name *",
            "placeholder_name": "Edit client name",
            "sap": "SAP identifier *",
            "placeholder_sap": "Edit client SAP identifier",
            "nif": "NIF *",
            "placeholder_nif": "Edit client NIF",
            "cancel": "Cancel",
            "save": "Save"
        }
    },
    "deactivateClientDialog": {
        "title": "Deactivate client",
        "sap": "SAP identifier:",
        "nif": "NIF:",
        "text1": "The client is going to be deactivated, are you sure?",
        "text2": "All users associated with the client will be automatically deactivated, so they will not be able to connect",
        "deactivate": "Deactivate client"
    },
    "activateClientDialog": {
        "title": "Activate client",
        "sap": "SAP identifier:",
        "nif": "NIF:",
        "text1": "The client is going to be activated, are you sure?",
        "text2": "The users associated with the client must be activated manually before they can access.",
        "activate": "Activate client"
    },
    "documentationClientDialog": {
        "title": "Client documentation",
        "sap": "SAP identifier: ",
        "nif": "NIF: ",
        "table": {
            "documentName": "Document name",
            "type": "Type",
            "size": "Size"
        },
        "availableDocumentation": "Available documents",
        "input":{
            "label": {
                "fileName": "Name",
                "startDate": "Start date",
                "endDate": "Expiration date",
                "description": "Description",
                "uploadFile": "Select file"
            },
            "addDocument": "Add document",
            "editDocument": "Edit document",
            "add": "Add",
            "save": "Save document",
            "cancel": "Cancel",
            "close": "Close",
            "upload": "Add document",
            "delete": "Delete document",
            "deleteText": "The following document will be deleted, are you sure?"
        }
    },
    "deleteClientDialog": {
        "title": "Delete client",
        "sap": "SAP identifier:",
        "nif": "NIF:",
        "text1": "The client is going to be deleted, are you sure?",
        "text2": "All users associated with the client will be automatically deleted, so they will not be able to connect.",
        "delete": "Delete client"
    },
    "stateTag": {
        "active": "Active",
        "inactive": "Inactive"
    },
    "toaster": {
        "success": {
            "createClient": "Client created successfully",
            "updateClient": "Client updated successfully",
            "createDocument": "Document created successfully",
            "updateDocument": "Document updated successfully",
            "deleteDocument": "Document deleted successfully"
        },
        "error": {
            "createDocument": "Error to create document",
            "updateDocument": "Error to update document",
            "deleteDocument": "Error to delete document"
        }
    }
};